import React from "react";
import Hexagon from "./Hexagon";
import {navigation,platform, nerdlet} from "nr1";
import { openEntityWithOneDayDuration } from "./buildServiceItems";
import { useAccount } from "./account-context";
const StoreHexGrid = ({ currentStores, onStoreClick, t }) => {
  const { accountId } = useAccount();
  return (
    <div className="hexagon-grid">
      {currentStores.length > 0 ? (
        currentStores.map((store) => (
          <div key={store.id} className="hexagon-item"   onClick={(e) => {
    e.stopPropagation();
    
let entityGuid = 'MzU0NzU3M3xWSVp8REFTSEJPQVJEfGRhOjEyMTc2ODIz';
openEntityWithOneDayDuration(entityGuid,store.id, (store?.issue  || "").toUpperCase(), accountId);}}>
          <Hexagon color={store.color} size={40} storeId={store.id} issue={store.issue?store.issue:''} />
          <div className="hexagon-label">{store.id}</div>
        </div>
      ))
    ) : (
      <div className="no-results">{t('noResults')}</div>
    )}
  </div>
);

// function openEntityWithOneDayDuration(entityGuid, storeId) {
//   const oneDay = 1 * 24 * 60 * 60 * 1000;

//   nerdlet.setConfig({
//     timePickerDefaultOffset: oneDay
//   })


//    navigation.openStackedNerdlet({
//     id: 'dashboards.detail',
//     urlState: {
//       entityGuid: entityGuid,//"MzU0NzU3M3xWSVp8REFTSEJPQVJEfGRhOjEyMTc2ODIz",
//       selectedVariables: {
//         "entity": storeId
//       }
//     }
//   })

  
}
export default StoreHexGrid;